import { useCallback } from 'react';
import type {
  ElectricityHeatSteamLocation,
  FlagType,
} from '/business/shared/state/selectors/application/electricityHeatSteam/electHeatSteamTypes';
import { useSelector } from 'react-redux';
import getElectConsumptionDataSelector from '/business/shared/state/selectors/application/electricityHeatSteam/getElectConsumptionDataSelector';

export default function useGetIsFlagTypeAvailable(editId: string | null) {
  const consumptionData = useSelector(getElectConsumptionDataSelector);

  const isFlagTypeAvailable = useCallback(
    (selectedLocation: ElectricityHeatSteamLocation | null, flagId: FlagType, includeExistingEntry: boolean) => {
      if (!selectedLocation) {
        return false;
      }
      const relevantConsumption = consumptionData.filter((data) => {
        if (data.location_id === selectedLocation.id && data.flag_type === flagId) {
          if (data.id?.toString() === editId && editId) {
            return includeExistingEntry;
          }
          return true;
        }
        return false;
      });
      return relevantConsumption.length === 0;
    },
    [consumptionData],
  );
  return isFlagTypeAvailable;
}
